module.exports = {
  wait: 'Proszę czekać...',
  login: 'Zaloguj',
  password: 'Hasło',
  select_product: 'Wybierz produkt',
  enter_code: 'Wpisz kod SMS',
  phone_required: 'Numer telefonu jest wymagany',
  role_required: 'Wybierz co najmniej 1 rolę',
  name_required: 'Imię jest polem wymaganym',
  phone_number: 'Numer telefonu',
  phone: 'Numer telefonu',
  email: 'E-mail',
  adduser: 'Dodaj użytkownika',
  updateuser: 'Aktualizuj użytkownika',
  back: 'z powrotem',
  clear: 'jasne',
  roles: 'roles',
  delete: 'Czy na pewno chcesz usunąć?',
  deleteAdmin: 'To konto nie może zostać usunięte, ponieważ jest używane przez zespół pomocy technicznej Zlick. Jeśli nadal uważasz, że to konto powinno zostać usunięte, skontaktuj się z nami pod adresem support@zlick.it',
  accountStatus: 'Status konta',
  user_email: 'E-mail użytkownika',
  user_name: 'Nazwa użytkownika',
  placeholderemail: 'Proszę podać adres e-mail użytkownika',
  placeholdername: 'Wprowadź nazwę użytkownika',
  placeholderrole: 'Wprowadź role, które chcesz dodać lub zaktualizować',
  product: 'Produkt',
  price: 'Cena',
  new_price: 'Nowa cena',
  product_required: 'Produkt jest wymagany',
  payment_type_required: 'Typ płatności jest wymagany',
  verif_code: 'Kod SMS',
  order_confirmed: 'Zamówienie potwierdzone',
  continue: 'Dalej',
  cancel: 'Anuluj',
  start_order: 'Rozpocznij nowe zamówienie',
  p_c_sms: 'SMS potwierdzający zamówienie',
  close: 'Zamknij',
  order_info: 'Informacje o zamówieniu',
  pin_required: 'PIN jest wymagany',
  pin_length: 'PIN musi zawierać {length} znaków',
  wrong_pin: 'Nieprawidłowy PIN. Spróbuj ponownie.',
  max_pin_attempts: 'Nieprawidłowy kod wpisany 3 razy. Proszę wyślij nowy SMS.',
  something_went_wrong: 'Coś poszło nie tak. Proszę spróbować ponownie.',
  send_sms: 'Wyślij SMS',
  refundNotAllowed: 'Zwroty nie są dozwolone.',
  refundTooOld: 'Zwrot nie mógł zostać przetworzony, transakcja jest starsza niż 185 dni. Proszę skontaktować się z zespołem Zlick w celu ręcznego przetworzenia.',
  alreadyRefunded: 'Już zwrócono.',
  refundFailed: 'Zwrot nieudany.',
  manualRefund: 'Ręczny proces zwrotu.',
  createdAt: 'Stworzony w',
  updatedAt: 'Zaktualizowano o godz',
  referenceNumber: 'Numer referencyjny',
  productName: 'Nazwa produktu',
  transactionType: 'Typ transakcji',
  period: 'Okres',
  amount: 'Kwota',
  user: 'Użytkownik',
  refundReason: 'Zwrot / Zamówienie',
  reload: 'Reload',
  transactions: 'Transakcje',
  orders: 'Zamówienia',
  telemarketing: 'Telemarketing',
  addsubscriber: 'Dodaj subskrybenta',
  searchPlaceholder: 'Wpisz zapytanie',
  password_required: 'Hasło jest wymagane',
  password_requirements: 'Hasło musi zawierać minimum {length} znaków, zawierać minimum jedną wielką literę i jedną małą literę, oraz minimum {numbers}',
  something_required: '{something} jest wymagane',
  something_not_valid: '{something} jest niepoprawne',
  temp_password_label: 'Aktualne hasło tymczasowe',
  new_password: 'Nowe hasło',
  confirm_password: 'Powtórz nowe hasło',
  password_not_match: 'Hasła nie są identyczne',
  firstName: 'Imię',
  lastName: 'Nazwisko',
  completeRegistration: 'Zakończ rejestrację',
  subscriber_added: 'Subscriber added',
  carrier: 'Telecom / Nośnik',
  expiryDate: 'Data wygaśnięcia',
  paymentType: 'Typ płatności',
  name: 'wyjaśnienie',
  transaction_id: 'Identyfikator transakcji',
  clientUserId: 'klient iD użytkownika',
  addSubHead: 'Dodaj subskrybenta',
  telemarketingHead: 'Telemarketing',
  ordersHead: 'Zamówienia',
  trxHead: 'Transakcje',
  webhooksHead: 'Webhooki',
  changePasswordHead: 'Zmień hasło',
  cancelOrderDialog: 'Czy na pewno chcesz anulować to zamówienie?',
  unsubscribe: 'Wypisz się',
  refundReason_required: 'Wymagany jest powód zwrotu',
  reset: 'Resetowanie',
  noStatus: 'brak statusu',
  oneOffPayment: 'Płatność jednorazowa',
  ok: 'Dobrze',
  transactionsHistory: 'Historia transakcji',
  webhook_logs: 'Webhooks',
  refundDialogInfo: 'Please let us know why You are making this refund:',
  refund: 'Refund',
  noResponseFromWebhook: 'No Response received from the webhook, try retrying the webhook.',
  urlWebHook: 'URL',
  eventId: 'Event Id',
  status: 'Status',
  request: 'Request',
  responses: 'Responses',
  requestBody: 'Request Body',
  responseBody: 'Response Body',
  retryAttempts: 'Retry Attempts',
  reports: 'Raporty'
}



// WEBPACK FOOTER //
// ./src/i18n/strings.pl.js